import React from 'react';
import axios from 'axios';
import { Button, FormGroup, Form, Input, FormFeedback } from 'reactstrap';
import SocialButtons from './socialButtons';
import OtpInput from 'react-otp-input';
import Separator from './separator';
import { validateEmail, checkIfUserExists, validatePassword } from '../validation/validateElements';
import LoaderElement from '../../chrome/elements/icons/loaderElement';
import './loginBase.scss'

const buttonStyle = {
	padding: '0.75rem',
};

const OtpBoxStyle = {
    inputStyle: {
		width: '3rem',
		height: '3rem',
		margin: '0 0.7rem',
		fontSize: '2rem',
		border: 'none',
		borderBottom: '1px solid #b6b6b6',
		borderRadius: 0
	},

	focusStyle: {
		border: 'none',
		outline: 'none',
		borderBottom: '1px solid #2874EB',
		borderRadius: 0
    }
}

export default class LogInBase extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			email: '',
			session: this.props.session,
			otpGenerated: false,
			password: '',
			passwordValid: {},
			passwordFeedback: '',
			otp: '',
			numInputs: 4,
			separator: '-',
			isDisabled: false,
			hasErrored: false,
			isInputNum: false,
			minLength: 0,
			maxLength: 40,
			emailValid: {},
			emailFeedback: '',
			otpFeedback:'',
			loading: false,
			_csrf: props._csrf
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleEmailChange = this.handleEmailChange.bind(this);
		this.handlePasswordChange = this.handlePasswordChange.bind(this);
	}
	handleEmailChange(event) {
		this.setState({
			email: event.target.value.trim(),
			session: this.state.session,
		});
	}
	handlePasswordChange(event) {
		this.setState({
			password: event.target.value.trim(),
			session: this.state.session,
		});
	}

	validateAll() {
		if (!validateEmail(this.state.email)) {
			this.setState({ emailValid: { valid: false }, emailFeedback: 'Please enter valid email address', loading: false });
			return false;
		}
		this.setState({
			emailValid: { valid: true }, emailFeedback: '',
		});
		return true;
	}

	  handleOtpRequest = (event) => {
		event.preventDefault();
		const {_csrf} = this.state;
		try {
		  const email = this.state.email;
		  this.setState({ otp: '', otpFeedback: '' });
		  if (this.validateAll()) { 
			axios({
				method: 'post',
				url: `/api/v1.1/emailOtp/generalOtp`,
				data: {
				  email,
				  _csrf
				},
			  }).then((res) => {
				  this.setState({
					otpGenerated: true
				  });
				});
		} else {
			this.setState({
				loading: false,
			});
		}
		 
		} catch (errors) {
		  this.props.errors = true;
		}
	
	  }

	  handleOtpChange = otp => {
		this.setState({ otp });
	  };

	  verifyOtp = (event) => {
		event.preventDefault();
		const {otp, email, _csrf} = this.state;
		try {
			axios({
				maxRedirects : 0,
				method: 'post',
				url: `/signin-otp`,
				data: {
					email: email,
					otp: otp,
					_csrf
				},
			})
			.then((response) => {
				if(response.data.success) {
					if (window.eventDispatcher) {
						window.eventDispatcher.dispatchEventSync('loginSuccess', {method: 'email-otp'}, {amplitude: true});
					}
					window.location.replace('/')
				} else {
					if(!response.data.signup_required) {
						this.setState({
							otpFeedback: response.data.message
						})
					} else {
						try {
							axios({
							  method: "post",
							  url: `/api/v1.1/checkout/guest`,
							  data: {
								email,
								_csrf
							  }
							}).then(() => {					
							  if (window.eventDispatcher) {
								window.eventDispatcher.dispatchEventSync('continueAsGuestSuccess', {}, { amplitude: true });
							  }					
							  // NOTE: warning! this funny line reloads the page and forces proper referer header.
							  // Don't change unless backend no longer requires it
							  window.location.href = window.location.href;
							});
						  } catch (err) {
							this.setState({
							  loading: false
							});					
							if (window.eventDispatcher) {
							  window.eventDispatcher.dispatchEvent('continueAsGuestFailed', {}, { amplitude: true });
							}
						  }
					}					
				}					
			})
		} catch (errors) {
		  console.log('outer errors==>>',errors )
		  this.setState({
			otpFeedback: response.data.message
		  })
		}
	  }


	handleSubmit(event) {
		event.preventDefault();
		this.setState({
			loading: true,
		});

		if (window.eventDispatcher) {
			window.eventDispatcher.dispatchEvent('loginInitiated', {method: 'email-password'}, {amplitude: true});
		}

		try {
			const data = new FormData();
			data.append('email', this.state.email);
			data.append('password', this.state.password);
			if (this.validateAll()) {
				checkIfUserExists(this.state.email).then((response) => {
					if (response.data) {
						validatePassword(this.state.password, this.state.email, this.state._csrf).then((response) => {
							if (response.data.success) {
								axios({
									maxRedirects : 0,
									method: 'post',
									url: `/signin`,
									data: {
										email: this.state.email,
										password: this.state.password,
										_csrf: this.state._csrf,
									},
								})
									.then((response) => {
										if (window.eventDispatcher) {
											window.eventDispatcher.dispatchEventSync('loginSuccess', {method: 'email-password'}, {amplitude: true});
										}
										window.location.reload();
									});
							} else if (response.data.socal) {
								this.setState({
									passwordValid: { valid: false },
									passwordFeedback: 'We couldn\'t find a password for this account. Try a social login.',
									loading: false,
								});

								if (window.eventDispatcher) {
									window.eventDispatcher.dispatchEvent('loginFailed', {method: 'email-password', reason: 'social-login'}, {amplitude: true});
								}
							} else {
								this.setState({
									passwordValid: { valid: false },
									passwordFeedback: 'Your password is incorrect, please try again.',
									loading: false,
								});

								if (window.eventDispatcher) {
									window.eventDispatcher.dispatchEvent('loginFailed', {method: 'email-password', reason: 'wrong-password'}, {amplitude: true});
								}
							}
						}).catch((err) => {
							this.setState({
								passwordValid: { valid: false },
								passwordFeedback: 'Your password is incorrect, please try again.',
								loading: false,
							});

							if (window.eventDispatcher) {
								window.eventDispatcher.dispatchEvent('loginFailed', {method: 'email-password', reason: 'wrong-password'}, {amplitude: true});
							}
						});
					} else {
						this.setState({
							emailValid: { valid: false },
							emailFeedback: 'You don\'t seem to be an existing user. Please sign up first.',
							loading: false,
						});

						if (window.eventDispatcher) {
							window.eventDispatcher.dispatchEvent('loginFailed', {method: 'email-password', reason: 'not-a-user'}, {amplitude: true});
						}
					}
				}).catch(() => {
					this.setState({
						emailValid: { valid: false },
						emailFeedback: 'You don\'t seem to be an existing user. Please sign up first.',
						loading: false,
					});

					if (window.eventDispatcher) {
						window.eventDispatcher.dispatchEvent('loginFailed', {method: 'email-password', reason: 'not-a-user'}, {amplitude: true});
					}
				});
			} else {
				this.setState({
					loading: false,
				});
			}
		} catch (err) {
			this.setState({ loading: false });
		}
	}

	render() {
		const { otpGenerated, 
				numInputs,
				separator,
				isDisabled,
				hasErrored,
				isInputNum,
				otp,
				otpFeedback
			} = this.state
		return (
			<div style={{ width: '100%' }} className="login-panel">
				<SocialButtons text="Log In" />
				<Separator />
				<Form id="signin">
					<FormGroup style={{ width: '100%' }}>
						<Input required {...this.state.emailValid} type="email" name="email" id="email" placeholder="Email Address" value={this.state.email} onChange={this.handleEmailChange} disabled={this.state.otpGenerated}/>
						<FormFeedback style={{ display: 'block' }}>{this.state.emailFeedback}</FormFeedback>
					</FormGroup>
					<FormGroup style={{ width: '100%' }}>
					{otpGenerated ? (
						<div>
							<div className="margin-top--small">
								<OtpInput
								inputStyle={OtpBoxStyle.inputStyle}
								className="otp-box"
								numInputs={numInputs}
								isDisabled={isDisabled}
								hasErrored={hasErrored}
								errorStyle="error"
								focusStyle={OtpBoxStyle.focusStyle}
								onChange={this.handleOtpChange}
								// separator={<span>{separator}</span>}
								isInputNum={isInputNum}
								shouldAutoFocus
								value={otp}
								/>
							{otpFeedback ?  <p style={{color:'red', margin:'10px 0 10px 20px'}}>{otpFeedback}</p>: null}
						
						</div>
						<div className="otpbtn-row" style={{ paddingTop: '1rem'}}>
							<Button
							color = "primary"
							className="btn btn-full-width margin-top--large"
							disabled={otp.length < numInputs}
							onClick={this.verifyOtp}
							>
							Verify OTP
							</Button>

							<div className="resend-opt-wrapper">
								Not received your code ? 
							<span
								id="resendOtp"
								disabled={isDisabled}
								onClick={this.handleOtpRequest}
							>
							resend OTP
							</span>
							<p style={{ paddingTop: '5px', fontSize: '12px'}}>This OTP will be valid for next 5 mins.</p>
							</div>

						</div>
						</div>
						) : <>
							<Input required {...this.state.passwordValid} type="password" name="password" id="password" placeholder="Password" value={this.state.password} onChange={this.handlePasswordChange} />
							<FormFeedback style={{ display: 'block' }}>{this.state.passwordFeedback}</FormFeedback>
						</>} 
						

					</FormGroup>
					{!otpGenerated ? 
					<div style={{
						marginTop: '1rem', marginBottom: '1rem', width: '100%', textAlign: 'center',
					}}
					>
						<Button
							disabled={this.state.loading}
							color="primary"
							className="btn-full-width"
							style={buttonStyle}
							type="submit"
							onClick={this.handleSubmit}
						>
							{this.state.loading ?
								<LoaderElement
									color="#FFFFFF"
									size="20"
									style={{
										paddingRight: '5px',
									}}
								/> : ''}Log In
						</Button>
						<p className="mr-auto" style={{ fontSize: '0.875rem', paddingTop: '0.5rem', marginBottom:30 }}>
							<span className="secondary-color float-right">
								<a className="secondary-a" href="/forgotPassword" >
								Forgot Password?
								</a>
							</span>
						</p>
						<Separator />
						<Button className="btn-full-width"
								style={{padding: 10}}
								color="secondary"
								onClick={this.handleOtpRequest}
						>
							Request OTP
						</Button>

					</div> : null }
				</Form>

				<style jsx>
					{`
						
					
					`}
          </style>									

			</div>
		);
	}
}
